import React from "react";
import { Controller } from "react-hook-form";
import { Form, Collapse, Select, Switch, InputNumber } from "antd";
import moment from "moment";
import { formItemLayout } from "../../../utils/UI";

const { Panel } = Collapse;
const { Option } = Select;

moment.tz.setDefault("Etc/UTC");

const ConnectionConfigurationElement = (props) => {
  const {
    control,
    errors,
    SFTPConnectionsData,
    isLoadingSFTPConnections,
    watch,
  } = props;

  return (
    <>
      <div className="container_ab">
        <Collapse defaultActiveKey={["2"]} expandIconPosition="end">
          <Panel header="Connection Configuration " key="2">
            <Form.Item
              {...formItemLayout}
              label="Connections"
              help={errors?.job?.connections?.message}
              required
              validateStatus={errors?.job?.connections ? "error" : ""}
            >
              <Controller
                control={control}
                name="job.connections"
                render={({ field }) => (
                  <Select
                    {...field}
                    loading={isLoadingSFTPConnections}
                    mode="multiple"
                    showSearch
                    placeholder="Select Connections"
                    showArrow
                    allowClear
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) !== -1
                      );
                    }}
                  >
                    {SFTPConnectionsData !== undefined
                      ? SFTPConnectionsData?.map((elem) => {
                          return (
                            <Option key={elem._id} value={elem._id}>
                              {elem.connectionName}
                            </Option>
                          );
                        })
                      : null}
                  </Select>
                )}
              />
            </Form.Item>

            <Form.Item {...formItemLayout} label="Connection Overrides">
              <Controller
                control={control}
                name="job.isConnectionOverrides"
                render={({ field: { value, onChange } }) => (
                  <Switch
                    checked={value}
                    onChange={(value) => {
                      onChange(value);
                    }}
                  />
                )}
              />
            </Form.Item>

            <div
              className="is_animation_1"
              style={
                watch("job.isConnectionOverrides") === true
                  ? { maxHeight: "500px" }
                  : { maxHeight: "0" }
              }
            >
              <Collapse defaultActiveKey={["3"]} expandIconPosition="end">
                <Panel header="Connection Overrides" key="3">
                  <Form.Item
                    {...formItemLayout}
                    label="Connection Timeout"
                    help={errors?.job?.connectTimeout?.message}
                    required
                    validateStatus={errors?.job?.connectTimeout ? "error" : ""}
                  >
                    <Controller
                      control={control}
                      name="job.connectTimeout"
                      render={({ field }) => (
                        <InputNumber
                          style={{ width: "100%" }}
                          {...field}
                          placeholder="Enter Connection Timeout Value"
                        />
                      )}
                    />
                  </Form.Item>
                  <Form.Item
                    {...formItemLayout}
                    label="Disconnect Timeout"
                    help={errors?.job?.disconnectTimeout?.message}
                    required
                    validateStatus={
                      errors?.job?.disconnectTimeout ? "error" : ""
                    }
                  >
                    <Controller
                      control={control}
                      name="job.disconnectTimeout"
                      render={({ field }) => (
                        <InputNumber
                          style={{ width: "100%" }}
                          {...field}
                          placeholder="Enter Disconnect Timeout Value"
                        />
                      )}
                    />
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="Download Zero Bytes">
                    <Controller
                      control={control}
                      name="job.downloadZeroBytes"
                      render={({ field: { value, onChange } }) => (
                        <Switch
                          checked={value}
                          onChange={(values) => {
                            onChange(values);
                          }}
                        />
                      )}
                    />
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="IS Passive">
                    <Controller
                      control={control}
                      name="job.isPassive"
                      render={({ field: { value, onChange } }) => (
                        <Switch
                          checked={value}
                          onChange={(values) => {
                            onChange(values);
                          }}
                        />
                      )}
                    />
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="Force IPv4">
                    <Controller
                      control={control}
                      name="job.forceIPv4"
                      render={({ field: { value, onChange } }) => (
                        <Switch
                          checked={value}
                          onChange={(values) => {
                            onChange(values);
                          }}
                        />
                      )}
                    />
                  </Form.Item>
                </Panel>
              </Collapse>
            </div>
          </Panel>
        </Collapse>
      </div>
    </>
  );
};

export default ConnectionConfigurationElement;
